'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var personalInformation = {
    COMMON_NAME: (0, _reactIntl.defineMessages)({
        NO_COMMON_NAME: {
            'id': 'formOverrides.personalInformation.NO_COMMON_NAME',
            'defaultMessage': 'I prefer to be referred to by the name on my passport.'
        }
    }),
    JACKET_SIZE: (0, _reactIntl.defineMessages)({
        EXPEDITION_PARKA_NOT_REQUIRED: {
            'id': 'formOverrides.personalInformation.EXPEDITION_PARKA_NOT_REQUIRED',
            'defaultMessage': 'Traveller does not require an Expedition Parka'
        }
    })
};

exports.default = personalInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/personalInformation.js
// module id = 1386
// module chunks = 0